/**
 * Registers the global delegated click handler for data-lightbox anchors.
 * Call once after the app mounts.
 */
import { LIGHTBOX_TRIGGER_SELECTOR } from "./lightboxContract";
import { openLightbox } from "./useLightbox";

function handleDocumentClick(e: MouseEvent) {
  const target = e.target as HTMLElement;
  const anchor = target.closest(LIGHTBOX_TRIGGER_SELECTOR) as HTMLAnchorElement | null;
  if (!anchor) return;

  const opened = openLightbox(anchor);
  if (opened) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}

export function initLightbox(): void {
  document.addEventListener("click", handleDocumentClick, true);
}
